import moment from 'moment';
import ErrorUtil from '../util/ErrorUtil';
import Service from './Service';

class CalendarioService extends Service {
    async recuperarCalendario(anos) {
        return this.getCalendarioApi().recuperarCalendario(anos);
    }
}
export default CalendarioService;
